<template>
    <div class="conversations">
        <ChatsContainer v-show="$vuetify.breakpoint.mdAndUp ||
                                ($vuetify.breakpoint.smAndDown &&
                                currentComponent === 'ChatsContainer')"
                        @changeCurrentComponent="changeCurrentComponent($event)"/>

        <ConversationContainer v-show="$vuetify.breakpoint.mdAndUp ||
                                ($vuetify.breakpoint.smAndDown &&
                                currentComponent === 'ConversationContainer')"
                               @changeCurrentComponent="changeCurrentComponent($event)"/>

        <DetailsContainer v-show="$vuetify.breakpoint.mdAndUp ||
                                ($vuetify.breakpoint.smAndDown &&
                                currentComponent === 'DetailsContainer')"
                          @changeCurrentComponent="changeCurrentComponent($event)"/>
    </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapState } from 'vuex'
import { UrlBase } from '@/services/configConversations'
import ChatsContainer from '@/pages/App/Conversations/ChatsContainer.vue'
import ConversationContainer from './ConversationContainer.vue'
import DetailsContainer from '@/pages/App/Conversations/DetailsContainer.vue'
import io from 'socket.io-client'
import notifications from '@/libs/notifications'

export default {
  beforeDestroy () {
    this.socket.disconnect()
    this.$store.commit('SET_SOCKET_CONVERSATIONS', null)
    clearInterval(this.interval)
  },
  components: { ChatsContainer, ConversationContainer, DetailsContainer },
  computed: {
    ...mapState({
      socket: state => state.conversations.socket
    })
  },
  async created () {
    EventBus.$on('changeCurrentComponent', ($event) => this.changeCurrentComponent($event))

    EventBus.$emit('toggleSideBar', false)

    const appInfo = await this.$store.dispatch('getAppInfo', { getStatistics: false })
    this.$store.commit('SET_APP_INFO', appInfo)
    await this.$store.dispatch('getAppCustomExtradatas')
  },
  data () {
    return {
      currentComponent: 'ChatsContainer'
    }
  },
  destroyed () {
    this.$store.commit('SET_CONVERSATIONS_USER', '')
    this.$store.commit('SET_SELECTED_ROOM', '')
    this.$store.commit('SET_ROOM_INFO', '')
  },
  methods: {
    changeCurrentComponent (component) {
      this.currentComponent = component
    },
    checkConfigurations (data) {
      const autoStarts = data.configurations.filter(element => {
        return element.name === 'autoStart'
      })

      this.$store.commit('SET_AUTO_STARTS', autoStarts)
    }
  },
  mounted () {
    EventBus.$emit('toggleSidebar', true)

    this.$store.commit('SET_SOCKET_CONVERSATIONS', io.connect(UrlBase, { path: '/keybe-conversations-socket' }))

    this.socket.on('connect', () => {
      this.socket.sendBuffer = []
      this.socket.emit('hostSubscribe', {
        jwt: this.$store.getters.token,
        appUUID: this.$store.getters.appUuid,
        companyUUID: this.$store.getters.companyUuid
      }, (err, data) => {
        if (err) return notifications.error(err.message)

        this.checkConfigurations(data)
      })
    })
  }
}
</script>

<style>
    @import "../../../styles/Conversations/Conversations.scss";
</style>
